export const keysStorage = {
  recentSearches: 'recentSearches',
};
